export const LOCAL_ORDER_CREATED_EVENT = 'brutos-local-order-created';

export const buildLocalOrderSessionMarker = (session = {}) => {
  const companyId = String(session?.user?.companyId || '').trim();
  const userId = String(session?.user?.id || session?.user?.email || '').trim();
  const browserSessionId = String(session?.browserSessionId || '').trim();
  if (!companyId || !userId || !browserSessionId) return '';
  return JSON.stringify([companyId, userId, browserSessionId]);
};

export const notifyLocalOrderCreated = (order, session) => {
  const tenantKey = String(session?.user?.companyId || '').trim();
  const orderTenantKey = String(order?.companyId || '').trim();
  const sessionMarker = buildLocalOrderSessionMarker(session);
  if (!order?.orderId || !tenantKey || orderTenantKey !== tenantKey || !sessionMarker || typeof window === 'undefined') {
    return false;
  }
  window.dispatchEvent(new CustomEvent(LOCAL_ORDER_CREATED_EVENT, {
    detail: { order, tenantKey, sessionMarker },
  }));
  return true;
};
